import { Card } from '@design-system';
import {
  EmailTab,
  InviteClientContext,
  useInviteClientProvider,
  type InviteClientProviderProps,
} from '@/features/invite-client';

interface InviteClientCardContentProps {
  title?: string;
  description?: string;
}

function InviteClientCardContent({
  title = 'Invite your first client',
  description = 'Tip: Invite yourself first to see exactly what your clients will experience',
}: InviteClientCardContentProps) {
  return (
    <Card className="gap-6 p-6">
      <div className="space-y-1">
        <h3 className="text-xl font-semibold text-gray-950">{title}</h3>
        <p className="text-foreground text-base">{description}</p>
      </div>
      <EmailTab
        showHeader={false}
        showAdditionalSettings={false}
      />
    </Card>
  );
}

export interface InviteClientCardProps extends InviteClientCardContentProps {
  onInviteSuccess?: InviteClientProviderProps['onInviteSuccess'];
  onClose?: InviteClientProviderProps['onClose'];
  prefillWithAdvisor?: boolean;
}

export function InviteClientCard({
  title,
  description,
  onInviteSuccess,
  onClose,
  prefillWithAdvisor,
}: InviteClientCardProps) {
  const storeValue = useInviteClientProvider({
    onInviteSuccess,
    onClose,
    prefillWithAdvisor,
    skipEmailWarning: true,
  });

  return (
    <InviteClientContext.Provider value={storeValue}>
      <InviteClientCardContent
        title={title}
        description={description}
      />
    </InviteClientContext.Provider>
  );
}
